import { render, staticRenderFns } from "./JobWidget.vue?vue&type=template&id=9a95b41c"
import script from "./JobWidget.vue?vue&type=script&lang=js"
export * from "./JobWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports